import { useSelector } from 'hooks';
import { useRecoilValue } from 'recoil';

import { Event, PlanningEntity } from '../../types';

import { selectedDayPartsAtom } from '../../atoms';

import { Box, styled } from '@mui/material';

import ActivityPanel from '../../components/ActivityPanel/ActivityPanel';

const Container = styled(Box)`
  flex: 1 1 100%;
  margin-left: 16px;
  overflow-y: auto;
  height: 100%;
`;

const PanelGrid = styled(Box)`
  display: flex;
  flex-flow: row wrap;
  column-gap: 12px;
  row-gap: 24px;
  padding: 16px;
  padding-right: 16px;
  min-height: 100%;
  box-sizing: border-box;
`;

interface RouteOverviewProps {
  activeEntityContainingSelection: string | null;
  planningEntities: PlanningEntity[] | null;
  connectAppointmentGrouping: (appointmentGroupingEntityId: string) => void;
  onChangeSelection?: (selectionIds: string[]) => void;
  onChangeActiveEntity?: (entityId: string) => void;
}

export default function RouteOverview({
  activeEntityContainingSelection,
  planningEntities = [],
  connectAppointmentGrouping,
  onChangeSelection,
  onChangeActiveEntity
}: RouteOverviewProps) {
  const selectedDayParts = useRecoilValue(selectedDayPartsAtom);
  const { hasActivityPlanningEditAccess } = useSelector(({ grants }) => grants);

  return (
    <Container>
      <PanelGrid>
        {planningEntities &&
          planningEntities.length > 0 &&
          planningEntities
            ?.filter(
              ({ schedules }) =>
                schedules[0] &&
                (selectedDayParts.length < 1
                  ? true
                  : selectedDayParts.includes(
                      schedules[0]?.dayPart ?? 'MORNING'
                    ))
            )
            ?.map((props) => {
              const schedule = props.schedules[0];

              return (
                <ActivityPanel
                  key={schedule?.appointmentGrouping?.entityId}
                  activeEntityContainingSelection={
                    activeEntityContainingSelection
                  }
                  readOnly={!hasActivityPlanningEditAccess}
                  showEmployeeName
                  onConnectClick={() => {
                    if (schedule?.appointmentGrouping) {
                      connectAppointmentGrouping(
                        schedule.appointmentGrouping!.entityId
                      );
                    }
                  }}
                  onChangeSelection={onChangeSelection}
                  onChangeActiveEntity={onChangeActiveEntity}
                  {...schedule}
                  headerName={schedule.name}
                  events={(schedule?.events as Event[]) ?? []}
                  planningEntityType={props.type}
                  planningEntityId={props.id}
                  planningEntityIdentifier={props.planningEntityIdentifier}
                  isOverrulingExternalDuty={schedule.isOverrulingExternalDuty}
                />
              );
            })}
      </PanelGrid>
    </Container>
  );
}
